// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#iFrameAnexo[data-v-b74df046] {\n  width: 100%;\n  height: 100vh;\n  border: none;\n}", ""]);
// Exports
module.exports = exports;
